// ✅ ملف التسجيل المعدّل (Signup.js) بكود المسؤول والتعديلات

import React, { useState } from "react";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { sendEmailVerification } from "firebase/auth";
import { toast } from "react-toastify";
import './Homepage.css';
import logo from '../assets/logo.png';
import { useLanguage } from '../contexts/LanguageContext';

const Signup = () => {
  const { language, toggleLanguage } = useLanguage();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [adminCode, setAdminCode] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showAdminCode, setShowAdminCode] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleAdminCodeVisibility = () => {
    setShowAdminCode(!showAdminCode);
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    const auth = getAuth();

    if (!role) {
      toast.role("✅ الرجاء اختيار الدور.");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await sendEmailVerification(user);

      // التحقق من كود المسؤول لجميع الأدوار المطلوبة
      if (["admin", "restaurant", "driver"].includes(role)) {
        if (adminCode !== process.env.REACT_APP_ADMIN_CODE) {
          await auth.currentUser.delete();
          toast.error("❌كود المسئول غير صحيح");
          return;
        }
      }

      // إنشاء بيانات المستخدم في Firestore
      const userData = {
        name,
        email,
        role,
        balance: 0,
        createdAt: new Date()
      };
      
      if (role === "driver") {
        userData.status = "متاح";
      } else if (role === "restaurant") {
        userData.status = "نشط";
      }
      

      const collectionName = role === "admin" ? "admins" : role === "restaurant" ? "restaurants" : "drivers";
      await setDoc(doc(db, collectionName, user.uid), userData);

      toast.success("✅ تم التسجيل بنجاح! تم إرسال رسالة تفعيل إلى بريدك.");
      navigate("/login");
    } catch (error) {
      console.error("❌ فشل التسجيل: " + error.message);
      toast.error("❌ فشل التسجيل: " + error.message);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    marginBottom: '16px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '14px',
    transition: 'border-color 0.3s, box-shadow 0.3s',
    boxSizing: 'border-box',
    backgroundColor: '#f9f9f9'
  };

  const roleButtonStyle = {
    flex: 1,
    padding: '10px',
    margin: '0 5px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.3s ease'
  };

  const buttonStyle = {
    width: '100%',
    padding: '12px',
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '500',
    boxShadow: '0 2px 6px rgba(40, 167, 69, 0.3)',
    transition: 'background-color 0.3s ease'
  };

  return (
    <div className="landing-page" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <header className="modern-header">
        <div className="header-content">
          <span className="app-title">AT Delivery</span>
          <button className="lang-switch-circle" onClick={toggleLanguage} title={language === 'ar' ? 'English' : 'العربية'}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ff7e5f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12h20" />
              <path d="M12 2a15.3 15.3 0 0 1 0 20" />
              <path d="M12 2a15.3 15.3 0 0 0 0 20" />
            </svg>
          </button>
        </div>
      </header>
      <main>
        <div className="welcome-card" style={{maxWidth: 400}}>
          <h1 style={{marginBottom: 24}}>{language === 'ar' ? 'إنشاء حساب جديد' : 'Create New Account'}</h1>
          <form onSubmit={handleSignup}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              marginBottom: '24px'
            }}>
              {['admin', 'restaurant', 'driver'].map((roleOption) => (
                <button
                  key={roleOption}
                  onClick={() => setRole(roleOption)}
                  style={{
                    ...roleButtonStyle,
                    backgroundColor: role === roleOption ? '#007bff' : '#f0f0f0',
                    color: role === roleOption ? 'white' : '#333',
                    boxShadow: role === roleOption ? '0 2px 6px rgba(0,123,255,0.3)' : 'none'
                  }}
                >
                  {roleOption === 'admin' ? 'مسؤول' : roleOption === 'restaurant' ? 'مطعم' : 'سائق'}
                </button>
              ))}
            </div>

            <input 
              type="text" 
              placeholder="الاسم" 
              value={name} 
              onChange={(e) => setName(e.target.value)} 
              required 
              style={inputStyle} 
            />
            
            <input 
              type="email" 
              placeholder="البريد الإلكتروني" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
              style={inputStyle}
            />
            
            <div style={{ position: 'relative', marginBottom: '16px' }}>
              <input 
                type={showPassword ? "text" : "password"} 
                placeholder="كلمة المرور" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
                style={{ ...inputStyle, marginBottom: 0 }} 
              />
              <div
                style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  zIndex: 1
                }}
                onClick={togglePasswordVisibility}
                title={showPassword ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}
              >
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="#777" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  {showPassword ? (
                    <>
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </>
                  ) : (
                    <>
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </>
                  )}
                </svg>
              </div>
            </div>

            {['admin', 'restaurant', 'driver'].includes(role) && (
              <div style={{ position: 'relative', marginBottom: '24px' }}>
                <input 
                  type={showAdminCode ? "text" : "password"} 
                  placeholder="كود المسؤول" 
                  value={adminCode} 
                  onChange={(e) => setAdminCode(e.target.value)} 
                  required 
                  style={{ ...inputStyle, marginBottom: 0 }} 
                />
                <div
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    zIndex: 1
                  }}
                  onClick={toggleAdminCodeVisibility}
                  title={showAdminCode ? "إخفاء كود المسؤول" : "إظهار كود المسؤول"}
                >
                  <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="#777" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    {showAdminCode ? (
                      <>
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                        <line x1="1" y1="1" x2="23" y2="23" />
                      </>
                    ) : (
                      <>
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </>
                    )}
                  </svg>
                </div>
              </div>
            )}

            <button className="register-btn" type="submit">
              {language === 'ar' ? 'إنشاء حساب جديد' : 'Create New Account'}
            </button>
          </form>
          <div style={{marginTop: 16}}>
            <button className="login-btn" onClick={() => navigate('/login')}>
              {language === 'ar' ? 'تسجيل الدخول' : 'Login'}
            </button>
          </div>
        </div>
      </main>
      <footer>
        <div className="footer-links">
          <a href="/privacy">{language === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy'}</a>
          <span>|</span>
          <a href="/terms">{language === 'ar' ? 'الشروط والأحكام' : 'Terms of Service'}</a>
          <span>|</span>
          <a href="/return">{language === 'ar' ? 'سياسة الاسترجاع' : 'Return Policy'}</a>
          <span>|</span>
          <a href="/pricing">{language === 'ar' ? 'الأسعار' : 'Pricing'}</a>
          <span>|</span>
          <a href="/about">{language === 'ar' ? 'من نحن' : 'About Us'}</a>
          <span>|</span>
          <a href="/contact">{language === 'ar' ? 'اتصل بنا' : 'Contact Us'}</a>
          <span>|</span>
          <a href="/faq">{language === 'ar' ? 'الأسئلة الشائعة' : 'FAQ'}</a>
          <span>|</span>
          <a href="/guide">{language === 'ar' ? 'دليل المستخدم' : 'User Guide'}</a>
          <span>|</span>
          <a href="/features">{language === 'ar' ? 'الميزات' : 'Features'}</a>
          <span>|</span>
          <a href="/delete-account">{language === 'ar' ? 'حذف الحساب' : 'Delete Account'}</a>
        </div>
        <div className="footer-copy">
          {language === 'ar'
            ? 'جميع الحقوق محفوظة © AT Delivery 2025'
            : 'All rights reserved © AT Delivery 2025'}
        </div>
      </footer>
    </div>
  );
};

export default Signup;
